export default{ 
    setMainInfo({ commit }, payload) {
        commit('SET_MAININFO',payload);
    },
    setMainDataStructure({ commit }, payload) {
        console.log('main structure triggered:',payload);
        commit('SET_MAINDATASTRUCTURE',payload);
    },
    setEndPoint({ commit }, payload) {
        commit('SET_ENDPOINT',payload);
    }, 
    setCallBack({ commit }, payload) {
        commit('SET_CALLBACK',payload);
    },
    setProfileId({ commit }, payload) {
        commit('SET_PROFILEID',payload);
    },
    setCurrentMainInfo({ commit }, payload) {
        commit('SET_CURRENTMAININFO',payload);
    },
    setCurrentMainDataStructure({ commit }, payload) {
        console.log("updating current structure:",payload);
        commit('SET_CURRENTMAINDATASTRUCTURE',payload);
    },
    
}